import { render, staticRenderFns } from "./ProductVideo.vue?vue&type=template&id=4a0fd6fa&scoped=true&"
import script from "./ProductVideo.vue?vue&type=script&lang=js&"
export * from "./ProductVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProductVideo.vue?vue&type=style&index=0&id=4a0fd6fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0fd6fa",
  null
  
)

export default component.exports